import { createReducer, on } from '@ngrx/store';
import { NarzedziaActions } from './narzedzia.actions';
import { DEFINICJA_NARZEDZI_WYKONAWCZYCH } from './narzedzia.const';

export interface NarzedziaWykonawcze {
  id: string;
  desktop: boolean;
  mobile: boolean;
  dane?: any;
}

export interface NarzedziaState {
  maksZIndex: number;
  kolejnosc: number;
  narzedziaWykonawcze: NarzedziaWykonawcze[];
  aktywneNarzedzieId?: string;
}

export const NarzedziaInitialState: NarzedziaState = {
  maksZIndex: 61,
  kolejnosc: 1,
  narzedziaWykonawcze: [],
  aktywneNarzedzieId: undefined
};

export const narzedziaReducer = createReducer(
  NarzedziaInitialState,

  on(NarzedziaActions.uruchomNarzedzie, (state, { identyfikator, dane }) => {
    const istnieje = state.narzedziaWykonawcze.some(n => n.id === identyfikator);

    let nowaLista = [...state.narzedziaWykonawcze];
    if (!istnieje) {
      const noweNarzedzie = DEFINICJA_NARZEDZI_WYKONAWCZYCH.get(identyfikator);
      if (noweNarzedzie) {
        nowaLista.push({ ...noweNarzedzie, dane: dane });
      }
    } else if (dane) {
      // nowaLista = nowaLista.map(n => n.id === identyfikator ? { ...n, dane: dane } : n);
    }

    return {
      ...state,
      narzedziaWykonawcze: nowaLista,
      aktywneNarzedzieId: identyfikator
    };
  }),
  on(NarzedziaActions.ustawAktywneNarzedzie, (state, { narzedzieId }) => ({
    ...state,
    aktywneNarzedzieId: narzedzieId
  })),

  on(NarzedziaActions.zamknijNarzedzie, (state, { identyfikator }) => {
    const nowaLista = state.narzedziaWykonawcze.filter(n => n.id !== identyfikator);

    const nowyAktywnyId = state.aktywneNarzedzieId === identyfikator ? undefined : state.aktywneNarzedzieId;

    return {
      ...state,
      narzedziaWykonawcze: nowaLista,
      aktywneNarzedzieId: nowyAktywnyId
    };
  }),

  on(NarzedziaActions.aktualizujDane, (state, { identyfikator, dane }) => {
    const nowaLista = state.narzedziaWykonawcze.map(n =>
      n.id === identyfikator ? { ...n, dane: dane } : n
    );

    return {
      ...state,
      narzedziaWykonawcze: nowaLista,
      aktywneNarzedzieId: identyfikator
    };
  }),
  on(NarzedziaActions.schowajNarzedzie, (state, { identyfikator }) => {
    const nowyAktywnyId = state.aktywneNarzedzieId === identyfikator ? undefined : state.aktywneNarzedzieId;

    return {
      ...state,
      aktywneNarzedzieId: undefined
    };
  }),

  on(NarzedziaActions.reset, () => NarzedziaInitialState)
);
